module.exports = __webpack_public_path__ + "static/media/logo.4832cc6a.svg";